import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PLAYBACK_TOGGLE } from '../../actions/Playback';
import { WINDOW_SIZE_ENUM } from '../../types/IWindowSize';
import { checkTouch } from '../../utils/platform';
export default function PlayButton() {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const { play } = useSelector((state) => state.PlaybackStates);
    const { windowWidth } = useSelector((state) => state.BrowserState);
    const [isTouch, setIsTouch] = useState(false);
    useEffect(() => {
        var _a, _b, _c, _d;
        (_b = (_a = navigator) === null || _a === void 0 ? void 0 : _a.mediaSession) === null || _b === void 0 ? void 0 : _b.setActionHandler('play', playbackToggle);
        (_d = (_c = navigator) === null || _c === void 0 ? void 0 : _c.mediaSession) === null || _d === void 0 ? void 0 : _d.setActionHandler('pause', playbackToggle);
    }, []);
    useLayoutEffect(() => setIsTouch(checkTouch(window)), []);
    const icon = ((_a = play) === null || _a === void 0 ? void 0 : _a.state) === 'PLAYING' ? 'pause' : 'play';
    const variant = isTouch || windowWidth < WINDOW_SIZE_ENUM.SM ? 'primary' : 'glass';
    const size = isTouch ? 'small' : 'medium';
    const text = (_b = play) === null || _b === void 0 ? void 0 : _b.descriptions[(_c = play) === null || _c === void 0 ? void 0 : _c.state];
    const playbackToggle = () => {
        const { mediaId } = useSelector((state) => state.Media);
        dispatch({ type: PLAYBACK_TOGGLE, payload: { mediaId } });
    };
    if (!play) {
        return React.createElement("div", { style: { display: 'none' } });
    }
    return (React.createElement("music-button", { ariaLabelText: text || "play", onmusicActivate: playbackToggle, "icon-name": icon, "icon-only": true, variant: variant, size: size }));
}
;
